import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { generateColors } from "../../utils/helperFunctions";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

Chart.register(ArcElement, Tooltip, Legend);

const PieChart = ({ items }) => {
  // Process items data

  const { t } = useTranslation();
  const categoryTotals = items.reduce((acc, item) => {
    const category = item.category || "Unknown";
    acc[category] = (acc[category] || 0) + (Number(item.total) || 0);
    return acc;
  }, {});
  const colores = generateColors(Object.keys(categoryTotals).length);

  // Chart data configuration
  const data = {
    labels: Object.keys(categoryTotals).map((label) => {
      const fieldValue = label || "";
      const labelKey = `EditableModal.selectValues.${fieldValue}`;
      const translatedLabel = i18n.exists(labelKey) ? t(labelKey) : fieldValue;
      return translatedLabel;
    }),
    datasets: [
      {
        data: Object.values(categoryTotals),
        backgroundColor: colores,
        hoverOffset: 4,
        borderWidth: 2,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          padding: 20,
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const fieldValue = context.label || "";
            const labelKey = `EditableModal.selectValues.${fieldValue}`;
            const translatedLabel = i18n.exists(labelKey) ? t(labelKey) : fieldValue;
            const label = translatedLabel;
            const value = context.parsed || 0;
            return `${label}: $${value.toFixed(2)}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ height: "400px" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
